import { Component, OnInit } from '@angular/core';
import { DialogPosition, MatDialog } from '@angular/material/dialog';
import { ChatroomWindowComponent } from './chatroom-window/chatroom-window.component';
import { SignalRService } from './services/signalr-service';
import { ChatHomeComponent } from './chat-home/chat-home.component';

@Component({
    selector: 'app-messenger',
    templateUrl: './messenger.component.html',
    styleUrls: ['./messenger.component.scss'],
    standalone: false
})
export class MessengerComponent implements OnInit {
  
  HelpIcon = false;
  
  constructor(
    public dialog: MatDialog,
    private signalRService: SignalRService
  ) { }

  ngOnInit(): void {

    // Start the SignalR connection
    // this.signalRService.startConnection();
  }

  openDialog(event: any) {
    let position: DialogPosition = {
      right: 25 + 'px',
      bottom: 90 + 'px',
    };
  
    // this.dialog.closeAll();
    this.dialog.open(ChatHomeComponent, {
      hasBackdrop: false,
      position: position,
      width: "25%",
      height: "70%",
      panelClass: 'dialog-animation',
    });
  }
}
